module.exports = {"localhost_contract":"http://localhost:63744","localhost_mediation":"http://localhost:53885","stage_azure_contract":"https://web-app-ws-stg.azurewebsites.net","stage_azure_mediation":"https://web-app-ws-stg.azurewebsites.net","production_azure_contract":"https://web-app-ws.azurewebsites.net","production_azure_mediation":"https://web-app-ws.azurewebsites.net"}


//////////////////
// WEBPACK FOOTER
// ./src/api/config.json
// module id = 799
// module chunks = 0